// 한국 시간대 오프셋 (밀리초)
const KST_OFFSET = 9 * 60 * 60 * 1000;

/**
 * 현재 시간을 한국 시간대의 Date 객체로 반환
 * @returns {Date} 한국 시간대의 현재 시간
 */
export const getKoreanNow = () => {
  const now = new Date();
  return new Date(now.getTime() + KST_OFFSET);
};

/**
 * 한국 시간 기준으로 오늘 날짜를 YYYY-MM-DD 형식으로 반환
 * @returns {string} YYYY-MM-DD 형식의 오늘 날짜
 */
export const getKoreanToday = () => {
  return getKoreanNow().toISOString().split('T')[0];
};

/**
 * 주어진 날짜 문자열을 한국 시간대 Date 객체로 변환
 * @param {string} dateStr - YYYY-MM-DD 형식의 날짜 문자열
 * @returns {Date} 한국 시간대 기준 Date 객체
 */
export const parseKoreanDate = (dateStr) => {
  return new Date(dateStr + 'T00:00:00+09:00');
};

/**
 * 두 날짜 사이의 일수 차이 계산 (한국 시간대 기준)
 * @param {string|Date} startDate - 시작 날짜
 * @param {string|Date} endDate - 종료 날짜
 * @returns {number} 일수 차이
 */
export const getDaysDifference = (startDate, endDate) => {
  const start = typeof startDate === 'string' ? parseKoreanDate(startDate) : startDate;
  const end = typeof endDate === 'string' ? parseKoreanDate(endDate) : endDate;
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
};

// 목표일까지 남은 일수를 계산하는 함수
export const getDaysUntilTarget = (targetDate) => {
  if (!targetDate) return null;
  
  const now = new Date();
  // 한국 시간으로 변환
  const korTime = new Date(now.getTime() + (9 * 60 * 60 * 1000));
  const target = new Date(targetDate);
  
  return Math.ceil((target - korTime) / (1000 * 60 * 60 * 24));
};

// 타임스탬프를 한국 시간 기준으로 포맷하는 함수
export const formatDateTime = (timestamp) => {
  const date = new Date(timestamp);
  // 한국 시간으로 변환
  const korTime = new Date(date.getTime() + (9 * 60 * 60 * 1000));
  
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  
  return `${korTime.getMonth() + 1}월 ${korTime.getDate()}일 (${days[korTime.getDay()]}) ${
    korTime.getHours().toString().padStart(2, '0')}:${
    korTime.getMinutes().toString().padStart(2, '0')}`;
};

// 타임스탬프를 간단한 날짜 형식으로 포맷하는 함수
export const formatDate = (timestamp) => {
  if (!timestamp) return null;
  
  const date = timestamp.seconds ? new Date(timestamp.seconds * 1000) : new Date(timestamp);
  // 한국 시간으로 변환
  const korTime = new Date(date.getTime() + (9 * 60 * 60 * 1000));
  
  return `${korTime.getFullYear()}-${(korTime.getMonth() + 1).toString().padStart(2, '0')}-${korTime.getDate().toString().padStart(2, '0')}`;
};

// 목표일까지 남은 일수를 계산하되, 초과된 경우 양수로 반환
export const getDaysOverTarget = (targetDate) => {
  if (!targetDate) return null;
  
  const now = new Date();
  // 한국 시간으로 변환
  const korTime = new Date(now.getTime() + (9 * 60 * 60 * 1000));
  const target = new Date(targetDate);
  
  const diffDays = Math.floor((korTime - target) / (1000 * 60 * 60 * 24));
  return diffDays > 0 ? diffDays : 0; // 초과된 일수만 반환, 아직 안 지났으면 0
};